import React from 'react';
import clsx from 'clsx';
import { find, propEq, filter } from 'ramda';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import SubscriptionInfoPresenter from 'presenters/SubscriptionInfoPresenter';
import { Typography, Button } from '@material-ui/core';

import Switch from 'sharedComponents/Switch';

import useStyles from './useStyles';

const Connections = props => {
  const {
    subscriptionInfo,
    isAllConnectionsDisabled,
    onConnectionsChange,
    isConnectionsPending,
    onUpdate,
    isSubscriptionInfoUpdating,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const handleConnectionsOffChange = ({ target: { checked } }) => {
    onConnectionsChange({ disableAllConnections: checked });
  };

  const licensedStates = SubscriptionInfoPresenter.licensedStates(subscriptionInfo);

  const handleChangeStateEnabled = (enabled, id) => () => {
    const currentState = find(propEq('id', id))(licensedStates);
    if (currentState.enabled === enabled) return;

    const states = filter(state => state.id !== id, licensedStates);
    onUpdate({ licensedStates: [...states, { ...currentState, enabled }] });
  };

  return (
    <div>
      <Typography variant="h2" className={classes.header}>
        {t('components.SubscriptionPage.Connections.header')}
      </Typography>
      <div className={classes.switchBox}>
        <Typography variant="body1">{t('components.SubscriptionPage.Connections.stopAllConnections')}</Typography>
        <Switch
          checked={isAllConnectionsDisabled}
          onChange={handleConnectionsOffChange}
          disabled={isConnectionsPending}
          showLabel
        />
      </div>
      {licensedStates.map(({ name, id, enabled }) => {
        return (
          <div className={classes.stateItem} key={id}>
            <Typography variant="body1" className={classes.stateName}>
              {name}
            </Typography>
            <div className={classes.stateContrtols}>
              <Button
                color={enabled ? 'primary' : 'secondary'}
                className={clsx(classes.button)}
                onClick={handleChangeStateEnabled(true, id)}
                disabled={isAllConnectionsDisabled || isSubscriptionInfoUpdating}
              >
                {t('components.SubscriptionPage.Connections.enable')}
              </Button>
              <Button
                color={enabled ? 'secondary' : 'primary'}
                className={clsx(classes.button, classes.disabledButton)}
                onClick={handleChangeStateEnabled(false, id)}
                disabled={isAllConnectionsDisabled || isSubscriptionInfoUpdating}
              >
                {t('components.SubscriptionPage.Connections.disable')}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

Connections.propTypes = {
  subscriptionInfo: SubscriptionInfoPresenter.shape().isRequired,
  isAllConnectionsDisabled: PropTypes.bool.isRequired,
  isSubscriptionInfoUpdating: PropTypes.bool.isRequired,
  onConnectionsChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  isConnectionsPending: PropTypes.bool.isRequired,
};

export default Connections;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/Connections/Connections.js